import { EMPTY_STRING } from '../../helpers/TxpConstants';
import convertDateTimeToString from './convertDateTimeToString';
import ActivityType from '../../schema/innerSchema/ActivityType';
import BusStopData from '../../schema/viewSchema/BusStopData';
import LodgingReservation from '../../schema/LodgingReservation';
import TxpStrings from '../../schema/configSchema/TxpStrings';
import TxpDateTimeCallbacks from 'txp-data/lib/schema/configSchema/TxpDateTimeCallbacks';

/**
 * Extracts the lodging specific data needed for displaying the bus stop
 */
export default function populateLodgingBusStopData(
    lodgingEntity: LodgingReservation,
    activityType: ActivityType,
    txpStrings: TxpStrings,
    icon: string,
    txpDateTimeCallbacks?: TxpDateTimeCallbacks
): BusStopData {
    let collapsedText;
    let busStopLabel;
    let hotelName = lodgingEntity.lodgingBusiness ? lodgingEntity.lodgingBusiness.name : null;
    let ariaBusStopText;

    if (activityType == ActivityType.HotelCheckout) {
        busStopLabel = txpStrings.formatters.format(
            txpStrings.strings.hotelCheckOutText,
            EMPTY_STRING
        );
        let parsedCheckOutTimeText = convertDateTimeToString(
            lodgingEntity.checkoutTime,
            false /* isAccessible */,
            txpStrings.formatters,
            txpDateTimeCallbacks
        );
        ariaBusStopText = convertDateTimeToString(
            lodgingEntity.checkoutTime,
            true /* isAccessible */,
            txpStrings.formatters,
            txpDateTimeCallbacks
        );
        collapsedText = parsedCheckOutTimeText;
    } else if (activityType == ActivityType.HotelCheckin) {
        busStopLabel = txpStrings.formatters.format(
            txpStrings.strings.hotelCheckInText,
            EMPTY_STRING
        );
        let parsedCheckInTimeText = convertDateTimeToString(
            lodgingEntity.checkinTime,
            false /* isAccessible */,
            txpStrings.formatters,
            txpDateTimeCallbacks
        );
        ariaBusStopText = convertDateTimeToString(
            lodgingEntity.checkinTime,
            true /* isAccessible */,
            txpStrings.formatters,
            txpDateTimeCallbacks
        );
        collapsedText = parsedCheckInTimeText;
    }

    return {
        busStopLabel: busStopLabel,
        busStopText: hotelName,
        collapsedText: collapsedText,
        ariaBusStopText: ariaBusStopText,
        icon: icon,
    } as BusStopData;
}
